import React from "react";
import { QuoteMarks } from "../../../components/common/Icons";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";
import * as styles from "./ParagraphHighlightedQuotes.module.scss";

interface QuoteData {
	quote: string;
	quotee: string;
	quoteeRole: string;
}
export interface ParagraphHighlightedQuotesProps {
	quoteBlock: QuoteData[];
}

export const getParagraphHighlightedQuotesProps = ({
	relationships: { field_quote_block },
}: Queries.ParagraphHighlightedQuotesDataFragment): ParagraphHighlightedQuotesProps => ({
	quoteBlock: field_quote_block.map((quoteBlock) => ({
		quote: quoteBlock.field_quote,
		quotee: quoteBlock.field_quotee,
		quoteeRole: quoteBlock.field_quotee_role,
	})),
});
export const ParagraphHighlightedQuotes: React.FC<
	ParagraphHighlightedQuotesProps
> = ({ quoteBlock }) => {
	return (
		<WrappedSection
			sectionName="ParagraphHighlightedQuotes"
			sectionColour={Colours.SUNSHINE_YELLOW}
		>
			<div>
				{quoteBlock.map(({ quote, quotee, quoteeRole }) => (
					<div key={quote} className={styles.content}>
						<div className={styles.quote}>
							<div className={styles.quotemarks}>
								<QuoteMarks height={"63px"} width={"48px"} />
							</div>
							<p className={styles.quotetext}>
								{quote}
								{"\u00A0"}
								<QuoteMarks height={"16px"} width={"11px"} />
							</p>
						</div>
						<p className={styles.quotee}>{quotee}</p>
						<p className={styles.quoteerole}>{quoteeRole}</p>
					</div>
				))}
			</div>
		</WrappedSection>
	);
};

export default ParagraphHighlightedQuotes;
